import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalChatbotComponent } from '@shared/components/modal/modal-chatbot/modal-chatbot.component';
import { ConcatenateSrcDirective } from '@shared/directives/concatenate-src/concatenate-src.directive';
import { ChatbotService } from '@shared/services/chatbot/chatbot.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-chat-button',
	standalone: true,
	imports: [ModalChatbotComponent, ConcatenateSrcDirective],
	templateUrl: './chat-button.component.html',
	styleUrl: './chat-button.component.scss'
})
export class ChatButtonComponent implements OnInit, OnDestroy {
	isPreviewOpen = false;
	isChatOpen = false;
	hasUnreadMessages = false;
	private sub = new Subscription();

	constructor(private chatbotService: ChatbotService) {}

	ngOnInit(): void {
		this.sub.add(
			this.chatbotService.unreadNotification$.subscribe(hasUnread => {
				if (hasUnread && !this.isChatOpen && !this.isPreviewOpen) {
					this.hasUnreadMessages = true;
				} else if (!hasUnread) {
					this.hasUnreadMessages = false;
				}

				// If we receive an unread notification but the user is actively viewing the chat,
				// immediately mark it as read so the localStorage tracker updates.
				if (hasUnread && (this.isChatOpen || this.isPreviewOpen)) {
					this.clearUnread();
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.sub.unsubscribe();
	}

	togglePreview(): void {
		this.isPreviewOpen = !this.isPreviewOpen;
		this.isChatOpen = false;
		if (this.isPreviewOpen) {
			this.clearUnread();
			this.chatbotService.refreshSession();
		}
	}

	openChat(): void {
		this.isPreviewOpen = false;
		this.isChatOpen = true;
		this.clearUnread();
		this.chatbotService.refreshSession();
	}

	closeChat(): void {
		this.isChatOpen = false;
	}

	returnToPreview(): void {
		this.isChatOpen = false;
		this.isPreviewOpen = true;
	}

	private clearUnread(): void {
		this.hasUnreadMessages = false;
		this.chatbotService.clearUnreadNotification();
	}
}
